import { useEffect } from 'react';
import type { LayoutChangeEvent } from 'react-native';
import Animated, {
  interpolate,
  useAnimatedRef,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';

import { styles } from './styles';
import type { SpinnerInlineProps } from './types';

const BAR_GAP = 0.2;

export const SpinnerInline = ({
  style,
  size: _size,
  ...props
}: SpinnerInlineProps) => {
  const containerRef = useAnimatedRef();
  const progress = useSharedValue(0);
  const containerWidth = useSharedValue(0);

  useEffect(() => {
    progress.value = withRepeat(withTiming(2, { duration: 1000 }), -1, true);
  }, [progress]);

  const handleLayout = (event: LayoutChangeEvent) => {
    containerWidth.value = event.nativeEvent.layout.width;
  };

  const rStyle = useAnimatedStyle(() => {
    const width = containerWidth.value;
    const edge = -width * (1 - BAR_GAP);

    return {
      transform: [
        {
          translateX: interpolate(progress.value, [0, 1, 2], [-edge, 0, edge]),
        },
      ],
    };
  });

  return (
    <Animated.View
      ref={containerRef}
      style={[styles.container, style]}
      onLayout={handleLayout}
      {...props}
    >
      <Animated.View style={[styles.bar, rStyle]} />
    </Animated.View>
  );
};
